import React from "react";
import { ChevronDown, ArrowUp, ArrowDown, Check } from "lucide-react";
import Cookies from "js-cookie";

const triggerCls =
    "flex items-center gap-1.5 px-3 h-12 rounded-lg text-sm font-medium cursor-pointer select-none " +
    "border border-base-content/20 bg-base-100 text-base-content " +
    "hover:bg-base-200 transition-colors duration-150";

const panelCls =
    "dropdown-content z-[9999] mt-1 rounded-xl shadow-xl " +
    "bg-base-100 border border-base-300 " +
    "p-1.5 w-52 flex flex-col gap-0.5";

const sectionLabel = "px-3 pt-3 pb-1 text-[10px] uppercase tracking-widest text-base-content/40 font-semibold";

const DropdownOrder = ({ viewMode, setViewMode, arrayDatosOrdenacion }) => {
    const save = (updated) => {
        setViewMode(updated);
        Cookies.set("viewModeProductos", JSON.stringify(updated), { expires: 7 });
    };

    const handleSort = (sortBy) => save({ ...viewMode, sortBy });
    const handleDir  = (dir)    => save({ ...viewMode, sortDirection: dir });

    const currentItem = arrayDatosOrdenacion?.find(i => i.valor === viewMode.sortBy);

    return (
        <div className="dropdown">
            <label tabIndex={0} className={triggerCls}>
                {viewMode.sortDirection === "asc"
                    ? <ArrowUp size={14} />
                    : <ArrowDown size={14} />
                }
                <span>{currentItem?.nombre ?? "Ordenar"}</span>
                <ChevronDown size={14} className="opacity-50 shrink-0" />
            </label>

            <ul tabIndex={0} className={panelCls}>
                <li className={sectionLabel}>Ordenar por</li>
                {arrayDatosOrdenacion?.map((item) => (
                    <li key={item.valor}>
                        <button
                            onClick={() => { handleSort(item.valor); document.activeElement?.blur(); }}
                            className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm w-full text-left
                                transition-colors duration-100
                                ${viewMode.sortBy === item.valor
                                    ? "bg-primary/10 text-primary font-semibold"
                                    : "text-base-content hover:bg-base-200"
                                }`}
                        >
                            {item.icon}
                            {item.nombre}
                            {viewMode.sortBy === item.valor && (
                                <Check size={13} className="ml-auto shrink-0 text-primary" />
                            )}
                        </button>
                    </li>
                ))}

                <li className={sectionLabel}>Dirección</li>
                <li>
                    <button
                        onClick={() => { handleDir("asc"); document.activeElement?.blur(); }}
                        className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm w-full text-left
                            transition-colors duration-100
                            ${viewMode.sortDirection === "asc"
                                ? "bg-primary/10 text-primary font-semibold"
                                : "text-base-content hover:bg-base-200"
                            }`}
                    >
                        <ArrowUp size={14} />
                        Ascendente
                        {viewMode.sortDirection === "asc" && (
                            <Check size={13} className="ml-auto shrink-0 text-primary" />
                        )}
                    </button>
                </li>
                <li>
                    <button
                        onClick={() => { handleDir("desc"); document.activeElement?.blur(); }}
                        className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm w-full text-left
                            transition-colors duration-100
                            ${viewMode.sortDirection === "desc"
                                ? "bg-primary/10 text-primary font-semibold"
                                : "text-base-content hover:bg-base-200"
                            }`}
                    >
                        <ArrowDown size={14} />
                        Descendente
                        {viewMode.sortDirection === "desc" && (
                            <Check size={13} className="ml-auto shrink-0 text-primary" />
                        )}
                    </button>
                </li>
            </ul>
        </div>
    );
};

export default DropdownOrder;
